import React from 'react';
import {
  ArrayField,
  AutocompleteInput,
  ChipField,
  Datagrid,
  Edit,
  List,
  NumberField,
  NumberInput,
  ReferenceField,
  ReferenceInput,
  Show,
  SimpleForm,
  SimpleShowLayout,
  SingleFieldList,
  TextField,
  TextInput,
} from 'react-admin';


import { useFormState } from 'react-final-form'

const nameLikeSearch = (n) => {
  if (n && n.length >= 2) {
    return {
      name__like: n,
    }
  }
}

const RecordTypeFilter = (props) => {
  const { values } = useFormState();
  return (<ReferenceInput enabled={values.projectId} label="RecordType" source="recordTypeId" reference="RecordType" filter={{project_id: values.projectId}} alwaysOn perPage={100} {...props}>
    <AutocompleteInput source="name"/>
  </ReferenceInput>)
}

const DescriptionFilters = [
  <NumberInput label="id" source="id" alwaysOn/>,
  <TextInput label="Name" source="name__like" alwaysOn/>,
  <ReferenceInput label="Project" source="projectId" reference="Project" filterToQuery={nameLikeSearch} alwaysOn>
    <AutocompleteInput source="name"/>
  </ReferenceInput>,
  <RecordTypeFilter alwaysOn/>,
];

export const DescriptionList = props => (
  <List {...props} filters={DescriptionFilters}>
    <Datagrid rowClick={'edit'}>
      <TextField source="id" />
      <TextField source="name" sortable={false}/>
      <TextField source="type" sortable={false}/>
      <ReferenceField label="RecordType" reference="RecordType" source="recordType.id" link={false} sortable={false}>
        <ChipField source="name" />
      </ReferenceField>
      <ArrayField source={'listValues'} sortable={false}>
        <SingleFieldList link={false}>
          <ChipField source={'value'} variant="outlined"/>
        </SingleFieldList>
      </ArrayField>
    </Datagrid>
  </List>
);

export const DescriptionShow = props => {
  return (
    <Show {...props}>
      <SimpleShowLayout>
        <TextField source="id" />
        <TextField source="name" />
        <TextField source="type" />
        <ReferenceField label="RecordType" reference="RecordType" source="recordType.id" link={false} >
          <ChipField source="name" />
        </ReferenceField>
        <ArrayField source={'listValues'}>
          <SingleFieldList link={false}>
            <ChipField source={'value'} variant="outlined"/>
          </SingleFieldList>
        </ArrayField>
      </SimpleShowLayout>
      <NumberField source="order"/>
    </Show>
  );
};

export const DescriptionEdit = props => {
  return (
    <Edit {...props} undoable={false}>
      <SimpleForm>
        <TextField source="id" />
        <TextInput source="name" multiline />
        <TextField source="type" />
        <ReferenceField label="RecordType" reference="RecordType" source="recordType.id" link={false} >
          <ChipField source="name" />
        </ReferenceField>
        <ArrayField source={'listValues'}>
          <SingleFieldList link={false}>
            <ChipField source={'value'} variant="outlined"/>
          </SingleFieldList>
        </ArrayField>
      </SimpleForm>
    </Edit>
  )
}
